module.exports = __webpack_public_path__ + "img/9788952776228.ed260546.jpg";